import { useTranslation } from 'react-i18next'

import { Markdown } from '@/components/Markdown'
import { SmartImage } from '@/components/SmartImage'
import { usePage } from '@/lib/queries'
import { personSchema, useSeo } from '@/lib/seo'
import { useLocale } from '@/lib/useLocale'

export function AboutPage() {
  const locale = useLocale()
  const { t } = useTranslation()
  const { data: page, isPending } = usePage(locale, 'about')

  const image = page?.cover?.variants.find((v) => v.label === 'full')?.url

  useSeo({
    title: page?.metaTitle || `${t('nav.about')} — ${t('site.name')}`,
    description: page?.metaDescription || t('site.defaultDescription'),
    path: '/about',
    locale,
    image,
    structuredData: [
      personSchema(t('site.name'), page?.metaDescription || t('site.defaultDescription'), image),
    ],
  })

  return (
    <div className="container-page py-14">
      <div className="grid gap-12 lg:grid-cols-[minmax(0,2fr)_minmax(0,3fr)]">
        {page?.cover && (
          <div className="lg:order-2">
            <SmartImage
              media={page.cover}
              locale={locale}
              alt={page.title}
              priority
              preferred="full"
              sizes="(min-width: 1024px) 40vw, 100vw"
              className="aspect-4/5 w-full rounded-[var(--radius-card)]"
            />
          </div>
        )}

        <article className={page?.cover ? 'lg:order-1' : 'max-w-2xl'}>
          <h1 className="text-4xl sm:text-5xl">{page?.title ?? t('nav.about')}</h1>

          {isPending ? (
            <div className="mt-8 animate-pulse space-y-3">
              <div className="h-4 rounded bg-stone-200/70" />
              <div className="h-4 w-11/12 rounded bg-stone-200/70" />
              <div className="h-4 w-9/12 rounded bg-stone-200/70" />
            </div>
          ) : (
            <Markdown source={page?.body ?? ''} className="mt-8" />
          )}
        </article>
      </div>
    </div>
  )
}
